<div class="wrapper__headerComponent container my-5">
  <div class="row align-items-center">
    <div class="col-12 center-elements-govco">
      <h2 class="text-center h3-tipografia-govco mb-0">{{"seleccion-entidad.nuevo" | translate}}</h2>
      <h4 class="text-center h4-tipografia-govco mb-0">
        {{"seleccion-entidad.duda" | translate}}
      </h4>
      <div class="text-center h4-tipografia-govco mb-0">
          <img src="assets/img/justino-btn.png" 
            class="img-justino"
            (click)="redirectToJustino()" 
            alt=""
          />
      </div>
      <!--
      <button class="btn-govco fill-btn-govco" id="arbol">
        {{"seleccion-entidad.asistente" | translate}}
      </button>
      -->
    </div>
  </div>
  <div class="container mt-5">
    <!--    <div class="container">-->
    <!--      <div class="row">-->
    <!--        <div class="col-12">-->
    <!--          <button class="btn-govco fill-btn-govco my-2"-->
    <!--            routerLink="/tramites/dnda">Creación DNDA</button>-->
    <!--        </div>-->
    <!--        <div class="col-12">-->
    <!--          <button routerLink="/tramites/dimar" class="btn-govco fill-btn-govco my-2">Creación DIMAR</button>-->
    <!--        </div>-->
    <!--        <div class="col-12">-->
    <!--          <button-->
    <!--            [routerLink]="['/tramites/ica/obtentor-variedad-vegetal']"-->
    <!--            [routerLinkActive]="'active'"-->
    <!--            class="btn-govco fill-btn-govco my-2">-->
    <!--            Obtentor variedad vegetal-->
    <!--          </button>-->
    <!--        </div>-->
    <!--        <div class="col-12">-->
    <!--          <button-->
    <!--            [routerLink]="['/tramites/superfinanciera/proteccion-consumidor']"-->
    <!--            [routerLinkActive]="'active'"-->
    <!--            class="btn-govco fill-btn-govco my-2">-->
    <!--            SuperFinanciera - Protección al consumidor-->
    <!--          </button>-->
    <!--        </div>-->
    <!--        <div class="col-12">-->
    <!--          <button-->
    <!--            [routerLink]="['/tramites/sic/competencia-desleal']"-->
    <!--            [routerLinkActive]="'active'"-->
    <!--            class="btn-govco fill-btn-govco my-2">-->
    <!--            SIC - Competencia desleal y propiedad industrial-->
    <!--          </button>-->
    <!--        </div>-->
    <!--        <div class="col-12">-->
    <!--          <button-->
    <!--            [routerLink]="['/tramites/sic/proteccion-consumidor']"-->
    <!--            [routerLinkActive]="'active'"-->
    <!--            class="btn-govco fill-btn-govco my-2">-->
    <!--            SIC - Protección a los consumidores-->
    <!--          </button>-->
    <!--        </div>-->
    <!--        <div class="col-12">-->
    <!--          <button-->
    <!--            [routerLink]="['/tramites/supersalud/crear-demanda']"-->
    <!--            [routerLinkActive]="'active'"-->
    <!--            class="btn-govco fill-btn-govco my-2">-->
    <!--            Tramites Supersalud-->
    <!--          </button>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </div>-->
    <div id="entidades">
      <div
        class="accordion-govco my-3"
        [id]="'faqAccordion' + entidad.Entidad"
        *ngFor="let entidad of entidades; let i = index">
        <div class="accordion-item">
          <h3 class="h4-tipografia-govco" [attr.id]="'heading' + i">
            <button
              class="button-accordion-govco"
              type="button"
              data-bs-toggle="collapse"
              [attr.data-bs-target]="'#collapse' + i"
              aria-expanded="false"
              [attr.aria-controls]="'collapse' + i"
              [attr.aria-label]="'...'"
              >
              <img
                [src]="entidad.Logo_Miniatura ? entidad.Logo_Miniatura : (entidad.Logo ? entidad.Logo : '../../../../assets/img/H-DIMAR.png')"
                alt="{{ entidad.Entidad }} logo"
                class="logo-img" />
              {{ entidad.Entidad }}
            </button>
          </h3>
          <div
            [attr.id]="'collapse' + i"
            class="accordion-collapse collapse"
            [attr.aria-labelledby]="'heading' + i"
            [attr.data-bs-parent]="'#faqAccordion' + entidad.Entidad">
            <div
              class="body-accordion-govco"
              *ngFor="let tramite of entidad.Tipo_Tramite; let i = index">
              <a
                [href]="
                  tramite.Funcionalidad ? tramite.Funcionalidad.url : null
                " (click)="guardarTramiteEnSession(tramite)"
                >{{ tramite.Nombre_Completo }}</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<app-selia-modal></app-selia-modal>
